<template>
  <div class="page-main">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">{{this.$route.params.namespace}}</li>
      </ol>
      <h1 class="page-title">{{ $t("member.labels.members") }}</h1>
      <div class="page-header-actions">
        <div class="row no-space w-120">
          <div class="col-xs-12 col-md-12">
            <div class="counter">
              <div class="counter-label p-t-5">{{ $t("member.labels.totalMembers") }}</div>
              <span class="counter-number font-weight-medium">{{pagination.total}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-content">
      <div class="panel">
        <div class="panel-body panel-form">
          <loading-indicator v-if="isLoading"></loading-indicator>
          <div v-else-if="isError">
          </div>
          <div v-else>
            <div class="p-b-15">
              <div class="row">
                <div class="col-xs-2 col-md-6">
                  <router-link v-bind:to="`/${$route.params.namespace}/team/members/create`" class="btn btn-primary">
                    <i class="icon md-plus" aria-hidden="true"></i><span class="text hidden-sm-down"> {{ $t("action.create") }} </span>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="table-striped table-hover table-responsive">
              <table class="table is-indent">
                <thead>
                  <tr>
                    <th class="cell-50" scope="col"></th>
                    <th class="cell-500" scope="col">{{ $t("account.labels.displayName") }}</th>
                    <th class="cell-500" scope="col">{{ $t("account.labels.email") }}</th>
                    <th class="cell-150 hidden-sm" scope="col">{{ $t("account.labels.role") }}</th>
                    <th class="cell-250"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, index) in users">
                    <td class="cell-50">
                      <a class="avatar">
                        <img v-if="user.display_image.sizes.default.url" class="img-fluid" v-bind:src="user.display_image.sizes.default.url" alt="image-profile">
                        <img v-else class="img-fluid" src="/static/images/user.png" alt="image-profile">
                      </a>
                    </td>
                    <td class="cell-550">
                      {{user.name}}
                    </td>
                    <td class="cell-500">
                      {{user.email}}
                    </td>
                    <td class="cell-150 hidden-sm">
                      <span v-if="user.role == 'manager'" class="tag tag-danger">Manager</span>
                      <span v-else class="tag tag-default">User</span>
                    </td>
                    <td class="cell-250">
                      <router-link v-bind:to="`/${$route.params.namespace}/team/members/${user.id}/edit`" class="btn btn-sm btn-default" data-toggle="tooltip" data-original-title="Edit">{{ $t("action.manage") }}
                      </router-link>
                      <button type="button" class="btn btn-sm btn-link" v-if="!user.is_enabled">
                        บัญชีนี้ถูกระงับการใช้งาน
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <paginate
            v-show="(pagination.total_page > 1)"
            v-bind:pageCount="pagination.total_page"
            v-bind:prevText="'«'"
            v-bind:nextText="'»'"
            v-bind:clickHandler="changePage"
            v-bind:containerClass="'pagination pull-right'"
            v-bind:pageClass="'page-item'"
            v-bind:pageLinkClass="'page-link'"
            v-bind:prevClass="'page-item'"
            v-bind:prevLinkClass="'page-link'"
            v-bind:nextClass="'page-item'"
            v-bind:nextLinkClass="'page-link'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from 'components/LoadingIndicator';

export default {
  components: {
    LoadingIndicator,
  },
  watch: {
    $route: 'fetchUsers',
  },
  data: function () {
    return {
      isLoading: false,
      isError: false,
      team: null,
      users: [],
      pagination: {
        total: 0,
        per_page: 20,
        current_page: 1,
        last_page: 0,
        from: 1,
        to: 1,
        next_page_url: null,
        prev_page_url: null,
        total_page: 0,
      },
    };
  },
  created: function() {
    this.isLoading = true;
    this.fetchUsers();
  },
  methods: {
    fetchUsers: function(page) {
      let url = `/api/teams/${this.$route.params.namespace}/users`;
      if (page) {
        url = `${url}?page=${page}`;
      }

      axios.get(url)
      .then((response) => {
        this.makePagination(response.data);
        this.users = response.data.data;
        this.isLoading = false;
        this.isError = false;

        window.scrollTo(0, 0);
      })
      .catch(() => {
        this.isLoading = false;
        this.isError = true;
      });
    },
    makePagination: function(data) {
      this.pagination.total = data.total;
      this.pagination.per_page = data.per_page;
      this.pagination.current_page = data.current_page;
      this.pagination.last_page = data.last_page;
      this.pagination.from = data.from;
      this.pagination.to = data.to;
      this.pagination.next_page_url = data.next_page_url;
      this.pagination.prev_page_url = data.prev_page_url;
      this.pagination.total_page = Math.ceil(data.total / data.per_page);
    },
    changePage: function(page) {
      this.fetchUsers(page);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// TeamMemberBrowser.vue?7d6c8f24